export default __webpack_public_path__ + "74890f739834dadd4cddde6f426ae30b.jpg";